import { CaretRight, CaretLeft, MagnifyingGlass, X } from "@phosphor-icons/react";

export const STATUS_CHIPS = [
  { key: "expected", label: "עתידי" },
  { key: "pending", label: "ממתין" },
  { key: "paid", label: "שולם" },
  { key: "invoiced", label: "חשבונית" },
  { key: "split", label: "פוצל" },
  { key: "refunded", label: "זיכוי" },
  { key: "cancelled", label: "בוטל" },
];

/**
 * List-view controls: month navigation, status chips, patient search,
 * therapist filter (admins in multi-therapist clinics). Fully controlled.
 */
function FinanceListFilters({
  monthLabel,
  onPrevMonth,
  onNextMonth,
  activeStatuses, // array of chip keys; empty = all
  onToggleStatus,
  onClearStatuses,
  searchTerm,
  onSearchChange,
  showTherapistFilter,
  therapists,
  selectedTherapistId, // "" = all
  onTherapistChange,
}) {
  return (
    <div className="fin-list-filters">
      <div className="fin-filters-row">
        <div className="fin-month-nav">
          <button
            type="button"
            className="fin-month-btn"
            onClick={onPrevMonth}
            aria-label="חודש קודם"
          >
            <CaretRight size={14} weight="bold" />
          </button>
          <span className="fin-month-label">{monthLabel}</span>
          <button
            type="button"
            className="fin-month-btn"
            onClick={onNextMonth}
            aria-label="חודש הבא"
          >
            <CaretLeft size={14} weight="bold" />
          </button>
        </div>

        <div className="fin-search-box">
          <MagnifyingGlass size={14} />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="חיפוש מטופל או תיאור..."
          />
          {searchTerm && (
            <button
              type="button"
              className="fin-search-clear"
              onClick={() => onSearchChange("")}
              aria-label="ניקוי חיפוש"
            >
              <X size={12} weight="bold" />
            </button>
          )}
        </div>

        {showTherapistFilter && (
          <select
            className="fin-therapist-select"
            value={selectedTherapistId}
            onChange={(e) => onTherapistChange(e.target.value)}
          >
            <option value="">כל המטפלים</option>
            {therapists.map((t) => (
              <option key={t.uid} value={t.uid}>
                {t.firstName} {t.lastName}
              </option>
            ))}
          </select>
        )}
      </div>

      <div className="fin-chips-row">
        <button
          type="button"
          aria-pressed={activeStatuses.length === 0}
          className={`fin-chip fin-chip-all ${activeStatuses.length === 0 ? "active" : ""}`}
          onClick={onClearStatuses}
        >
          הכל
        </button>
        {STATUS_CHIPS.map((chip) => {
          const isActive = activeStatuses.includes(chip.key);
          return (
            <button
              key={chip.key}
              type="button"
              aria-pressed={isActive}
              className={`fin-chip fin-chip-${chip.key} ${isActive ? "active" : ""}`}
              onClick={() => onToggleStatus(chip.key)}
            >
              {chip.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default FinanceListFilters;
